import React, { FC } from "react"
import useCountUp, { useCountUpParameters } from "./hooks/useCountUp"

const CountUp: FC<useCountUpParameters> = props => {
  const count = useCountUp(props)
  return <>{count}</>
}

export default CountUp
